import {setBattleValue, setCrewValue} from '../../redux-actions/battle-actions.js'
import {handleUserDataReceived} from './handle-user-data-received'
import {getUserDataFromFirebase} from './firebase-users'

/** Log in to Firebase (or already logged in) and get the user's data */
export function loginToBattleNetwork() {

  //Listen for the login change.
  window.firebase.auth().onAuthStateChanged(async user => {
    if (user) {
      // User is signed in.
      // var isAnonymous = user.isAnonymous;
      // var uid = user.uid;

      //use this userId to get my user info
      const formattedUserId = `client_${user.uid}`;

      setBattleValue({
        battlePlayerId: [formattedUserId] //save userID in state
      });

      setCrewValue({
        logggedInUserId: user.uid //Tell state that we are logged in.
      });

      //Go check if I have saved data
      const userData = await getUserDataFromFirebase(formattedUserId);
      if (userData) {
        //Handler will do something with this data and move us to next step
        handleUserDataReceived(userData);
      }

    } else {
      // User is not logged in.
      // ...
      //Now login annonymously
      window.firebase.auth().signInAnonymously().catch(function (error) {
        // Handle Errors here.
        // var errorCode = error.code;
        // var errorMessage = error.message;
        console.warn("error", error); //
      });
    }
  });
}


// WEBPACK FOOTER //
// ./src/battle/connection/firebase-auth.js